import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { PostService } from '../../../app/Services/post/post.service';
import { CarouselComponent } from '../../Components/shared/carousel/carousel.component';
import { RouterModule } from '@angular/router';
import { WINDOW_PROVIDERS, WINDOW } from '../../Services/window/window.service';

import { LocalizedDatePipe } from '../../Pipes/localizedDate/localized-date.pipe';

import { SwiperModule } from 'ngx-swiper-wrapper';
import { SWIPER_CONFIG } from 'ngx-swiper-wrapper';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';

import { SafeHtmlPipe } from '../../Pipes/safeHtml/safe-html.pipe';
import { SafeUrlPipe } from '../../Pipes/safe-url/safe-url.pipe';
import { SafeSrcUrlPipe } from '../../Pipes/safeSrc-url/safe-src-url.pipe';
import { FileUploadComponent } from '../../Components/shared/file-upload/file-upload.component';
import { ClipboardModule } from 'ngx-clipboard';
import { ActivityIndicatorComponent } from '../../Components/shared/activity-indicator/activity-indicator.component';
import { GlobalLoaderComponent } from '../../Components/shared/global-loader/global-loader.component';
import { TrustPilotComponent } from '../../Components/shared/trust-pilot/trust-pilot.component';
import { AuthModalComponent } from '../../Components/auth/auth-modal/auth-modal.component';
import { BreakLinesPipe } from '../../Pipes/break-lines/break-lines.pipe';

const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  direction: 'horizontal',
  slidesPerView: 1
};
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    SwiperModule,
    ClipboardModule,
  ],
  declarations: [
    CarouselComponent,
    LocalizedDatePipe,
    SafeHtmlPipe,
    SafeUrlPipe,
    SafeSrcUrlPipe,
    FileUploadComponent,
    ActivityIndicatorComponent,
    GlobalLoaderComponent,
    TrustPilotComponent,
    AuthModalComponent,
    BreakLinesPipe,
  ],
  exports: [
    CarouselComponent,
    SwiperModule,    
    LocalizedDatePipe,    
    SafeUrlPipe,
    SafeHtmlPipe,
    SafeSrcUrlPipe,
    ClipboardModule,
    GlobalLoaderComponent,
    TrustPilotComponent,
    AuthModalComponent,
    BreakLinesPipe,
  ],
  providers: [
    WINDOW_PROVIDERS,
    PostService,
    { provide: SWIPER_CONFIG, useValue: DEFAULT_SWIPER_CONFIG },
    LocalizedDatePipe,
    SafeHtmlPipe,
    SafeUrlPipe,
    SafeSrcUrlPipe,
    BreakLinesPipe,
  ],
  entryComponents: [
    FileUploadComponent,
    ActivityIndicatorComponent,
    AuthModalComponent,
  ],
})
export class SharedModule { }
